// extracted by mini-css-extract-plugin
export default {"nombre":"TablaEstadiosClubes_nombre__KSHkx","desde":"TablaEstadiosClubes_desde__fmrvo","hasta":"TablaEstadiosClubes_hasta__gcy9P"};